import { useNavigate } from "react-router-dom";
import { ROOM_LOOKUP } from "./roomLookup";
import dayjs from "dayjs";

const RoomSelect = () => {
  const navigate = useNavigate();

  const now = dayjs();

  return (
    <div
      style={{
        minHeight: "100vh",
        width: "100vw",
        fontFamily: "Barlow, sans-serif",
        display: "flex",
        flexDirection: "column",
        background: "#9fc490",
        color: "#19323c",
      }}
    >
      <div style={{ textAlign: "center", marginBottom: "3rem" }}>
        <h1
          style={{
            fontSize: "clamp(2rem, 4rem, 5rem)",
            margin: "2rem 0 2rem 0",
            textAlign: "center",
            width: "100%",
          }}
        >
          Select a Room
        </h1>

        <div style={{ marginBottom: "3rem", lineHeight: "1.2" }}>
          <div
            style={{
              fontSize: "1.2rem",
              textTransform: "uppercase",
              letterSpacing: "1px",
            }}
          >
            {now.format("dddd, MMMM D")}
          </div>
          <div style={{ fontSize: "1.5rem", fontWeight: "bold" }}>
            {now.format("hh:mm A")}
          </div>
        </div>
      </div>

      <div
        style={{
          display: "flex",
          flexWrap: "wrap",
          justifyContent: "center",
          gap: "1.5rem",
        }}
      >
        {Object.keys(ROOM_LOOKUP).map((roomKey) => (
          <button
            key={roomKey}
            onClick={() => navigate(`/?room=${roomKey}`)}
            style={{
              padding: "1.25rem 2rem",
              fontSize: "1.2rem",
              backgroundColor: "#19323c",
              color: "#fff",
              border: "none",
              borderRadius: "12px",
              cursor: "pointer",
              boxShadow: "0 4px 8px rgba(0,0,0,0.2)",
              transition: "background 0.3s",
            }}
            onMouseOver={(e) =>
              (e.currentTarget.style.backgroundColor = "#2a4753")
            }
            onMouseOut={(e) =>
              (e.currentTarget.style.backgroundColor = "#19323c")
            }
          >
            {ROOM_LOOKUP[roomKey].name}
          </button>
        ))}
      </div>

      <img
        src="/10xlogo.png"
        alt="Company Logo"
        style={{
          maxWidth: "120px",
          position: "absolute",
          bottom: "1rem",
          left: "1rem",
          zIndex: 100,
        }}
      />
    </div>
  );
};

export default RoomSelect;
